// this will make it compatible with Nuxt authentication
export const AUTH_INFO_COOKIE = 'glovo_auth_info'
export const IDENTITY_FLOW_ID = 'glovo_identity_flow_id'
